/**
 * [Phase 2b-D §6.3 R5] Step 7 - Nomination Order Mode (Live Only).
 *
 * Wizard scope: mode toggle only.
 *   form.nomination_order_mode: 'lotto' | 'preset'
 *
 * The drag-and-drop ordering UI lives in DraftLobby (§6.5.2). This step
 * just sets the league preference.
 *
 * Optional step: no validation gate.
 */
import { Info } from "lucide-react";

const Radio = ({ checked, onClick, label, sub, dataTestId }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={dataTestId}
    className={`w-full text-left flex items-start gap-3 rounded-lg border-2 px-4 py-3 transition-all ${
      checked
        ? "border-[#FF6B00] bg-[#FF6B00]/10"
        : "border-[#252525] bg-[#1C1C1C] hover:border-[#FF6B00]/40"
    }`}
  >
    <span
      className={`mt-1 inline-block h-4 w-4 rounded-full border-2 shrink-0 ${
        checked ? "border-[#FF6B00] bg-[#FF6B00]" : "border-[#A0A0A0]"
      }`}
    />
    <span className="flex-1">
      <span className="block font-display font-bold text-base text-[#F5F5F5]">
        {label}
      </span>
      {sub && <span className="block font-body text-xs text-[#A0A0A0] mt-0.5">{sub}</span>}
    </span>
  </button>
);

export default function Step7NominationOrder({ form, update, isSnake = false }) {
  const headerLabel = isSnake ? "Draft Order" : "Nomination Order";
  const headerSub = isSnake
    ? "How is the order in which managers pick determined?"
    : "How is the order in which managers nominate players determined?";
  return (
    <div data-testid="wizard-step-7" className="space-y-8">
      <header>
        <h2 className="font-display font-black text-3xl uppercase text-[#F5F5F5]">
          {headerLabel}
        </h2>
        <p className="font-body text-sm text-[#A0A0A0] mt-1">
          {headerSub}
        </p>
      </header>

      <section className="space-y-3">
        <Radio
          checked={form.nomination_order_mode === "lotto"}
          onClick={() => update({ nomination_order_mode: "lotto" })}
          label="Lotto"
          sub="Order randomized at draft start."
          dataTestId="wizard-step7-lotto"
        />
        <Radio
          checked={form.nomination_order_mode === "preset"}
          onClick={() => update({ nomination_order_mode: "preset" })}
          label="Preset"
          sub="Commissioner sets the order in the Draft Lobby once teams are seated."
          dataTestId="wizard-step7-preset"
        />
      </section>

      {form.nomination_order_mode === "preset" && (
        <div
          data-testid="wizard-step7-info-card"
          className="flex gap-3 bg-[#FF6B00]/10 border border-[#FF6B00]/30 rounded-xl px-4 py-3"
        >
          <Info size={16} className="text-[#FF6B00] shrink-0 mt-0.5" />
          <p className="font-body text-sm text-[#F5F5F5]">
            Drag-and-drop ordering happens in the Draft Lobby once your teams are seated.
          </p>
        </div>
      )}
    </div>
  );
}

export const validateStep7 = () => null;
